import { createAsyncThunk } from '@reduxjs/toolkit';
import { StatsCategoryProps } from 'Douleutaras/redux/data/stats/types';
import { makeRequest } from 'Douleutaras/services/apiClient';

const STATS_HALL_OF_FAME_API = 'api/public/v3/stats/hall-of-fame';

export interface HallOfFame {
  pro_id: number;
  tier: number;
  tier_trend: 'up' | 'down' | null;
  multiplier: string;
  rank: number;
  revenue: number;
  revenue_assigned_job: number;
  jobs: number;
  fulfillment_rate: number;
  mary_score: number;
  review_rating: number;
}

const hallOfFameMap: Map<string, Array<HallOfFame>> = new Map();

export const getHallOfFame = createAsyncThunk<Array<HallOfFame>, StatsCategoryProps>(
  'stats/hallOfFame/get',
  async ({ catId, subCatId }, api) => {
    const request = `${STATS_HALL_OF_FAME_API}/${catId}/${subCatId}`;
    if (!hallOfFameMap.has(request)) {
      const response = await makeRequest(
        request,
        {
          method: 'GET'
        }
      )(api);
      hallOfFameMap.set(request, response.data.data);

      return response.data.data;
    } else {
      return hallOfFameMap.get(request);
    }
  }
);
